import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { ProductGroupService } from '../services/product-group.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ProductGroupCreateComponent } from "./product-group-create/product-group-create.component";
import { Router } from '@angular/router';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

enum Tabs {
  Inicial = 'inicial',
  CriarEditar = 'criar-editar'
}

@Component({
  selector: 'app-prroduct-group',
  standalone: true,
  imports: [FormsModule, CommonModule, ProductGroupCreateComponent, TranslocoModule],
  templateUrl: './product-group.component.html',
  styleUrl: './product-group.component.css'
})
export class ProductGroupComponent implements OnInit {

  Tabs = Tabs;
  productGroups: any[] = [];
  filter = {
    name: '',
    inactive: ''
  };

  activeTab: string = Tabs.Inicial;

  constructor(
    private productGroupService: ProductGroupService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private router: Router,
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
    this.search();

  }

  search(): void {

    this.spinner.show();
    this.productGroupService.get(this.filter.name, this.filter.inactive)
      .subscribe({
        next: response => {
          this.productGroups = response;
          this.spinner.hide();
        },
        error: error => {
          console.log(error);
          this.spinner.hide();
        }
      })
  }

  createProductGroup(): void {
    this.router.navigate(['/product-group/create']);
  }

  editProductGroup(productGroupId: string): void {
    this.router.navigate(['/product-group/edit', productGroupId]);
  }

  dropdownOpen: { [key: number]: boolean } = {};

  toggleDropdown(productGroup: any): void {
    this.dropdownOpen[productGroup.id] = !this.dropdownOpen[productGroup.id];
  }

  inactiveActiveProductGroup(productGroup: any): void {

    this.spinner.show();
    this.productGroupService.activeOrInactive(productGroup.id, productGroup.inactive)
      .subscribe({
        next: response => {
          this.toastr.success(this.transloco.translate(productGroup.inactive ? 'productGroup.toast.deactivated' : 'productGroup.toast.activated'));
          this.search();
          this.toggleDropdown(productGroup);
          this.spinner.hide();
        },
        error: error => {

          this.toastr.error(this.transloco.translate('productGroup.toast.toggleError'));
          this.spinner.hide();
        }
      })
  }

  onProductCreated(): void {
    this.setActiveTab(Tabs.Inicial);
    this.search();
  }

  setActiveTab(tab: Tabs) {
    this.activeTab = tab;
  }
}